import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import inductiveReasoning from './inductiveReasoning.component';
import { authenticate } from '../../../../../core/core.middleware';

let inductiveReasoningModule = angular.module('inductiveReasoning', [
  uiRouter
])

  .config(($stateProvider) => {
    "ngInject";

    $stateProvider
      .state('course.inductiveReasoning', {
        url: '/courses/3/3b1/inductive-reasoning',
        component: 'inductiveReasoning',
        resolve: { authenticate }
      });
  })

  .component('inductiveReasoning', inductiveReasoning)

  .name;

export default inductiveReasoningModule;



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3b1/inductiveReasoning/inductiveReasoning.js